<template>
  <div class="type-list clearfix">
    <h4>{{ organ }}:</h4>
    <ul class = "lists clearfix">
      <li v-for="(item, index) in lists" :key="item.id" :class="{active:currentId === item.id,  hoverStyle: currentIndex !== index}" @click="setCurrentIndex(index, item)">
        {{ item.name }}
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  data () {
    return {
      currentIndex: 0
    }
  },
  props: {
    lists: {
      type: Array,
      default: function () {
        return [
        ]
      }
    },
    currentId: {
      type: String,
      default: '0'
    },
    organ: {
      type: String,
      default: '类别'
    },
    level: {
      type: String,
      default: 'first'
    }
  },
  methods: {
    setCurrentIndex (index, item) {
      if (this.level === 'first') {
        this.$emit('setType', index)
      }
      if (this.level === 'second') {
        this.$emit('setTypeList', index)
      }
    },
  },
  watch: {
    form: {
      lists:function(obj){
      },
      deep:true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
// @import "~@/styles/base.scss";
.type-list {
  // height: 94px;
  width: 100P;
  // background-color: pink;
  padding-top: 30px;
  // text-align: center;
  box-sizing: border-box;
  h4 {
    float: left;
    padding: 0;
    margin: 0;
    width: auto;
    height: 34px;
    font-size: 16px;
    line-height: 34px;
    text-align: left;
    margin-right: 20px;
  }
  .lists {
    // display: inline-block;
    // float: left;
    padding-left: 40px;
    li {
      float: left;
      padding: 0 10px;
      margin-right: 18px;
      margin-bottom: 20px;
      cursor: pointer;
      // width: 76px;
      height: 34px;
      border-radius: 3px;

      font-size: 14px;
      line-height: 34px;
      color: #333;
      &.active {
        color: #fff;
        background-color: #81A3EB;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/type-list/type-list.vue